// this file was prevaled
module.exports={"name":"mangane-fe","displayName":"Mangane","url":"https://github.com/BDX-town/Mangane","repository":"BDX-town/Mangane","version":"1.19.5-3745122","homepage":"https://bdx.town"};